import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Plus } from 'lucide-react';
import AddToCartModal from './AddToCartModal';
import { optimizedImageUrl, getMainImage } from '../utils/imageUrl';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const FREE_SHIPPING = 80;

const UpsellCard = ({ garment, onAdd }) => {
  const price = garment.sale_price != null && garment.sale_price < garment.price ? garment.sale_price : garment.price;
  return (
    <div className="snap-start shrink-0 w-[260px] sm:w-[300px] bg-white border border-neutral-200 flex items-center gap-4 p-3" data-testid={`upsell-item-${garment.id}`}>
      <img src={optimizedImageUrl(getMainImage(garment), 400)} alt={garment.name} className="w-20 h-24 object-cover bg-neutral-100 shrink-0" loading="lazy" />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold leading-tight line-clamp-2">{garment.name}</p>
        <p className="text-sm mt-1">{Number(price).toFixed(2)} €</p>
      </div>
      <button onClick={() => onAdd(garment)} className="flex items-center gap-1 text-sm font-semibold hover:opacity-60 transition-opacity shrink-0" data-testid={`upsell-add-${garment.id}`}>
        <Plus className="w-4 h-4" /> Añadir
      </button>
    </div>
  );
};

export const CartUpsell = ({ cart, subtotal }) => {
  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    axios.get(`${API}/garments`).then(({ data }) => {
      const inCart = new Set(cart.map((i) => i.garment_id));
      setItems(data.filter((g) => (g.gender || '').toUpperCase() === 'ACCESORIOS' && g.price > 0 && !inCart.has(g.id)).slice(0, 10));
    }).catch(() => setItems([]));
  }, [cart]);

  if (!items.length) return null;
  const missing = FREE_SHIPPING - subtotal;

  return (
    <section className="mt-6 bg-neutral-100 py-6 -mx-4 px-4 sm:mx-0 sm:px-6" data-testid="cart-upsell">
      <h2 className="text-xl font-black uppercase tracking-tight">Añade un poco más</h2>
      <p className="text-sm text-neutral-600 mt-1 mb-4" data-testid="cart-upsell-subtitle">
        {missing > 0 ? `Te faltan ${missing.toFixed(2)} € para el envío gratis: añade uno de estos artículos` : 'Ya tienes envío gratis. Completa tu look'}
      </p>
      <div className="flex gap-3 overflow-x-auto snap-x snap-mandatory pb-2 [scrollbar-width:thin]">
        {items.map((g) => <UpsellCard key={g.id} garment={g} onAdd={setSelected} />)}
      </div>
      <AddToCartModal isOpen={!!selected} onClose={() => setSelected(null)} garment={selected} />
    </section>
  );
};
